module.exports = __webpack_public_path__ + "06_bob_yellow.5911a0bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/06_bob_yellow.png
// module id = joNi
// module chunks = 0